import React, { useState, ReactElement, useCallback } from 'react';
import * as css from './Engagement.module.scss';
import 'src/css/themes.scss';
import { IconSeeMore } from 'src/content/icons';
import { Dialog, ScrollBar } from '@framework-controls/core';
import { strings } from 'src/localization';
import IconLoyaltyActive from 'src/content/icons/LoyaltyActive.svg';
import IconLoyaltyCross from 'src/content/icons/LoyaltyCross.svg';
import IconLoyaltyInactive from 'src/content/icons/LoyaltyInactive.svg';
import IconLoyaltyNone from 'src/content/icons/LoyaltyNone.svg';

const loyIconActive = (
    <div>
        <img className={css.loyIcon} alt='' src={IconLoyaltyActive}></img>
    </div>
);

const loyIconInactive = (
    <div>
        <img className={css.loyIcon} alt='' src={IconLoyaltyInactive}></img>
    </div>
);

const loyIconCross = (
    <div>
        <img className={css.loyIcon} alt='' src={IconLoyaltyCross}></img>
    </div>
);

const loyIconNone = (
    <div>
        <img className={css.loyIcon} alt='' src={IconLoyaltyNone}></img>
    </div>
);

const activeIcon: ReactElement = (
    <span className={css.infoBlock}>
        <div className={css.infoData}>{loyIconActive}</div>
        <div className={css.infoLit}>{strings.LoyaltyActiveStatus}</div>
    </span>
);

const inactiveIcon: ReactElement = (
    <span className={css.infoBlock}>
        <div className={css.infoData}>{loyIconInactive}</div>
        <div className={css.infoLit}>{strings.LoyaltyInactiveStatus}</div>
    </span>
);

const crossActiveIcon: ReactElement = (
    <span className={css.infoBlock}>
        <div className={css.infoData}>{loyIconCross}</div>
        <div className={css.infoLit}>{strings.LoyaltyCrossStatus}</div>
    </span>
);

const nonActiveIcon: ReactElement = (
    <span className={css.infoBlock}>
        <div className={css.infoData}>{loyIconNone}</div>
        <div className={css.otherData}>
            <div className={css.infoLit}>{strings.LoyaltyNoStatus}</div>
            <div className={css.otherLit}>{strings.LoyaltyOtherStatus}</div>
        </div>
    </span>
);

/**
 * Renders a "see more" trigger that opens a dialog explaining the
 * Toyota loyalty-status icons (Active, Inactive, Cross Active, None).
 * The dialog acts as an in-context legend for the loyaltyColor icon
 * shown in the Connected Vehicle diagnostics panel.
*/
const Engagement = () => {
    const [infoOpen, setInfoOpen] = useState(false);
    /** Handles the dialog open/close state */
    const toggleInfo = useCallback(function toggleInfoHandler() {
        setInfoOpen(prev => !prev);
    }, []);

    return (
        <div className={css.block}>
            <div className={css.icon}>
                <IconSeeMore onClick={() => toggleInfo()} />
            </div>
            <Dialog
                cssClasses={{
                    content: css.content,
                    paper: css.paper,
                    header: css.lightBoxHeader,
                }}
                isOpen={infoOpen}
                anchorOrigin={{
                    vertical: 'top',
                }}
                header={strings.Engagement.toUpperCase()}
                hideSave={true}
                hideCancel={true}
                onCancel={() => toggleInfo()}
                onBackDropClick={() => toggleInfo()}
                width={'full'}
            >
                <ScrollBar scrollVertical>
                    <div className={css.infoRow}>
                        {activeIcon}
                        {inactiveIcon}
                        {crossActiveIcon}
                        {nonActiveIcon}
                    </div>
                </ScrollBar>
            </Dialog>
        </div>
    );
};

export default Engagement;
